// extracted by mini-css-extract-plugin
export default {"container":"NvHomePageFaqs_container__w1M8e","questionSection":"NvHomePageFaqs_questionSection__6qPB0"};